module.exports = __webpack_public_path__ + "static/media/S_8.af24f528.png";